import { render, staticRenderFns } from "./copyrightRegistrationActivity.vue?vue&type=template&id=5212a076&scoped=true&"
import script from "./copyrightRegistrationActivity.vue?vue&type=script&lang=js&"
export * from "./copyrightRegistrationActivity.vue?vue&type=script&lang=js&"
import style0 from "./copyrightRegistrationActivity.vue?vue&type=style&index=0&lang=less&"
import style1 from "./copyrightRegistrationActivity.vue?vue&type=style&index=1&id=5212a076&lang=less&scoped=true&"
import style2 from "./copyrightRegistrationActivity.vue?vue&type=style&index=2&id=5212a076&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5212a076",
  null
  
)

export default component.exports